var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Axios from "axios";
import { UrlHelper } from "../helper/UrlWrapper";
var CommonService = (function () {
    function CommonService() {
    }
    CommonService.prototype.getMenu = function (params) {
        return Axios.post("supplierclientapi/supplierpower/menu", params);
    };
    CommonService.prototype.sendCode = function (params) {
        return Axios.get("supplierapi/login/sendcode", { params: params });
    };
    CommonService.prototype.verifyCode = function (params) {
        return Axios.post("supplierapi/login/verifycode", params);
    };
    CommonService.prototype.register = function (params) {
        return Axios.post("supplierclientapi/register", params);
    };
    CommonService.prototype.reregister = function (params) {
        return Axios.post("supplierclientapi/reregister", params);
    };
    CommonService.prototype.changePwd = function (params) {
        return Axios.post("supplierapi/login/updatepwd", params);
    };
    CommonService.prototype.getArea = function (params) {
        return Axios.get("basicapi/area", { params: params });
    };
    CommonService.prototype.getOperateCategory = function (params) {
        return Axios.get("basicapi/goodtypelist", { params: params });
    };
    CommonService.prototype.getClient = function (params) {
        return Axios.get("supplierclientapi/supplierpower/business", { params: params });
    };
    CommonService.prototype.getShop = function (params) {
        return Axios.post("/supplierclientapi/shop/condition_shop_list", params);
    };
    CommonService.prototype.getRuleShop = function (params) {
        return Axios.post("/supplierclientapi/shop/depot_rule_shop_list", params);
    };
    CommonService.prototype.getShopFilter = function (params) {
        return Axios.get("/supplierclientapi/shop/condition_shop_list", { params: params });
    };
    CommonService.prototype.getSupplierdepotOptions = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/get_options", { params: params });
    };
    CommonService.prototype.bindCheck = function (params) {
        return Axios.post("/supplierclientapi/customer/bind_check", params);
    };
    CommonService.prototype.getOrganList = function (params) {
        return Axios.get("supplierclientapi/supplierorgan/get_options", { params: params });
    };
    CommonService.prototype.getOrganDepot = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/get_organdepot_options", { params: params });
    };
    CommonService.prototype.getIsOpenAppointmentDeliveryTime = function (params) {
        return Axios.get("supplierclientapi/customer/get_is_open_appointment_delivery_time", { params: params });
    };
    CommonService.prototype.getIsOpenOCR = function (params) {
        return Axios.get("supplierclientapi/service/get_opened_api", { params: params });
    };
    CommonService.prototype.getOrderStatusList = function (params) {
        return Axios.get("supplierclientapi/deliveryorder/order_type_list", { params: params });
    };
    CommonService.prototype.getDepotList = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/get_options", { params: params });
    };
    CommonService.prototype.getReceiveDepotList = function (params) {
        return Axios.get("supplierclientapi/deliveryorder/receive_depot_list", { params: params });
    };
    CommonService.prototype.getAccountOptions = function (params) {
        return Axios.get("supplierclientapi/account/get_options", { params: params });
    };
    CommonService.prototype.getOrganBusiness = function (params) {
        return Axios.get("supplierclientapi/supplierorgan/get_organ_business", { params: params });
    };
    CommonService.prototype.getGroupNameList = function (params) {
        return Axios.get("supplierclientapi/customer/group_name_list", { params: params });
    };
    CommonService.prototype.updateExport = function (params) {
        return Axios.post("supplierclientapi/export/update", params);
    };
    CommonService.prototype.getExportDetail = function (params) {
        return Axios.get("supplierclientapi/export/detail", { params: params });
    };
    CommonService.prototype.getGoodslist = function (params) {
        return Axios.get("supplierclientapi/common/goods_list", { params: params });
    };
    CommonService.prototype.getGroupchilds = function (params) {
        return Axios.get("supplierclientapi/customer/group_childs", { params: params });
    };
    CommonService.prototype.getSettlementList = function () {
        return Axios.get("basicapi/settlement_list");
    };
    CommonService.prototype.getWechatQrcode = function (params) {
        return Axios.get("/supplierclientapi/common/get_wx_temporary_code", { params: params });
    };
    CommonService.prototype.bindAccmount = function (data) {
        return Axios.post("/supplierclientapi/wechat/scan_bind_official_account", data);
    };
    CommonService.prototype.unbindAccount = function (data) {
        return Axios.post("/supplierclientapi/wechat/unbind_official_account", data);
    };
    CommonService.prototype.exportCheck = function (url) {
        url = UrlHelper.addParam(url, 'check_export', 1);
        return Axios.get(url);
    };
    CommonService.prototype.exportCheckPost = function (url, params) {
        return Axios.post(url, __assign({}, params, { check_export: 1 }));
    };
    CommonService.prototype.getTemporaryTokenLoginQrcode = function (params) {
        return Axios.get("/supplierclientapi/common/login_qrcode", { params: params });
    };
    CommonService.prototype.getTemporaryTokenQrcodeStatus = function (params) {
        return Axios.get("/supplierclientapi/common/login_qrcode_state", { params: params });
    };
    CommonService.prototype.getClientGoodsType = function (params) {
        return Axios.get("basicapi/business_goodstype", { params: params });
    };
    CommonService.prototype.groupBusinessShop = function (params) {
        return Axios.post("supplierclientapi/shop/group_business_shop", params);
    };
    CommonService.createInstance = function () {
        CommonService.getInstance();
    };
    CommonService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    CommonService.prototype.getSupplierGoodsTypeList = function (params) {
        return Axios.get("/supplierclientapi/suppliergoodstype/type_list", { params: params });
    };
    CommonService.prototype.sendAppointmentDeliveryTime = function (params) {
        return Axios.get("/supplierclientapi/deliveryorder/save_appointment_delivery_time", { params: params });
    };
    CommonService.prototype.getDestroyAllValidate = function (params) {
        return Axios.get('/supplierclientapi/account/destroy_all_validate', { params: params });
    };
    CommonService.prototype.getDestroyAll = function (params) {
        return Axios.post('/supplierclientapi/account/destroy_all', params);
    };
    CommonService.prototype.getInvoiceTypeList = function (params) {
        return Axios.get("basicapi/invoice_type_list", { params: params });
    };
    CommonService.prototype.getLogisticsAllOptions = function (params) {
        return Axios.get("/supplierclientapi/shop/shop_logistics_option_all", { params: params });
    };
    CommonService.prototype.paramsToCode = function (params) {
        return Axios.post("/supplierclientapi/common/params_to_code", params);
    };
    return CommonService;
}());
export default CommonService;
